import { render, staticRenderFns } from "./DressListingg.vue?vue&type=template&id=4f3d4030&scoped=true"
import script from "./DressListingg.vue?vue&type=script&lang=js"
export * from "./DressListingg.vue?vue&type=script&lang=js"
import style0 from "./DressListingg.vue?vue&type=style&index=0&id=4f3d4030&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3d4030",
  null
  
)

export default component.exports